
import { mapState } from 'vuex'

export default {
  name: 'DefaultLayout',
  computed: mapState(['loadingMessageOverlay']),
  beforeMount() {
    window.onresize = () => this.$store.commit('setWindowWidth')

    // Inform user that popups are disabled
    const _windowOpen = window.open
    window.open = function () {
      const popup = _windowOpen.apply(this, arguments) 
      if (!popup || popup.closed || typeof popup.closed == 'undefined') {
        alert('Popups seem to be disabled. Please enable them in the browser settings.');
      }
      return popup
    }
  },
}
